exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-icon[data-v-26646538]{cursor:pointer;height:30px;width:30px}.edit-icon[data-v-26646538]{cursor:pointer;height:23px;width:25px}.delete-link[data-v-26646538]{color:red;font-weight:700;cursor:pointer}", ""]);

// exports
